var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackMsg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7 15V5.4C21.7 4.07452 20.6255 3 19.3 3H4.9C3.57452 3 2.5 4.07452 2.5 5.4V15C2.5 16.3255 3.57452 17.4 4.9 17.4H8.5L12.1 21L15.7 17.4H19.3C20.6255 17.4 21.7 16.3255 21.7 15ZM6.1 7.8C6.1 7.13726 6.63726 6.6 7.3 6.6H16.9C17.5627 6.6 18.1 7.13726 18.1 7.8C18.1 8.46274 17.5627 9 16.9 9H7.3C6.63726 9 6.1 8.46274 6.1 7.8ZM7.3 11.4C6.63726 11.4 6.1 11.9373 6.1 12.6C6.1 13.2627 6.63726 13.8 7.3 13.8H10.9C11.5627 13.8 12.1 13.2627 12.1 12.6C12.1 11.9373 11.5627 11.4 10.9 11.4H7.3Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMsg);
export default __webpack_public_path__ + "static/media/black-msg.ab10e74928f3dcaf9e1be4251650ceb0.svg";
export { ForwardRef as ReactComponent };